import React from 'react';

import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { alpha } from '@mui/material/styles';

export type BlackoutSortField = 'name' | 'from__c';

interface Props {
  columnCount: number;
  sortField: BlackoutSortField;
  sortDirection: 'asc' | 'desc';
  onSortChange: (field: BlackoutSortField) => void;
}

export default function BlackoutTableHeader({ columnCount, sortField, sortDirection, onSortChange }: Props) {
  return (
    <TableHead>
      <TableRow
        sx={{
          '& .MuiTableCell-head': {
            bgcolor: (theme) => alpha(theme.palette.info.main, 0.14),
            color: 'info.dark',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
          },
        }}
      >
        <TableCell colSpan={columnCount}>Parent Salesforce blackout dates</TableCell>
      </TableRow>
      <TableRow
        sx={{
          '& .MuiTableCell-head': {
            bgcolor: (theme) => alpha(theme.palette.info.main, 0.06),
            color: 'info.dark',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
          },
        }}
      >
        <TableCell />
        <TableCell sortDirection={sortField === 'name' ? sortDirection : false}>
          <TableSortLabel
            active={sortField === 'name'}
            direction={sortField === 'name' ? sortDirection : 'asc'}
            onClick={() => onSortChange('name')}
          >
            Name
          </TableSortLabel>
        </TableCell>
        <TableCell>Rooms (extracted)</TableCell>
        <TableCell sortDirection={sortField === 'from__c' ? sortDirection : false}>
          <TableSortLabel
            active={sortField === 'from__c'}
            direction={sortField === 'from__c' ? sortDirection : 'asc'}
            onClick={() => onSortChange('from__c')}
          >
            Range
          </TableSortLabel>
        </TableCell>
        <TableCell>Days (extracted)</TableCell>
      </TableRow>
    </TableHead>
  );
}
